import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';


import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

// URL to web api
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class ContectDetailsService {
  constructor(private http: HttpClient) {}

  getContectDetails(custId : any): Observable<any> {
    const get_url = baseApiUrl + 'subscriber/getContactDetails/' + custId;
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(res => res),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  insertContectDetails(contectDeatils_data : any) : Observable<any> {
      const post_url = baseApiUrl + 'subscriber/updateContactDetails';
      return this.http.post<any>(post_url, contectDeatils_data, httpOptions)
      .pipe(map(res => res),
      catchError((error: any) => {
        return throwError(error);
      })
      );
    }
}